import styles from '../../ApplicationMaintenance.module.scss';
import { useEffect, useState } from 'react';
import Section from '../../components/NewApplication/Section';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import { GetAppNotifications } from '../../_api';
import NotificationUpdate from './components/NotificationUpdate';
import { UpdateAppNotification } from '../../_api';
import AppManagementRequest from '../../../../Classes/ResponseModels/ApplicationManagement/AppManagementRequest';
import AppManagementModel from '../../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import Spinner from '../../../../components/UI/Spinner/Spinner';
import { GetWQSystems } from '../../_api';
const UpdateEmailNotifications = ({
	appID,
	currentUser,
	requirementNumber,
	readOnly,
}) => {
	// const [apiErrors, setApiErrors] = useState([]);
	const [appNotifications, setAppNotifications] = useState([]);
	const [multiWorkQueueNotifications, setMultiWorkQueueNotifications] =
		useState([]);
	const [isLoading, setIsLoading] = useState(true);
	//on load, retrieve existing email notifications for the selected app
	useEffect(() => {
		GetAppNotifications(appID)
			.then(data => {
				setAppNotifications(data.notificationEvents);
			})
			.then(x => {
				GetWQSystems(appID).then(resp => {
					if (resp.length && resp.length > 1) {
						setMultiWorkQueueNotifications(resp);
					}
				});
			})
			.then(x => setIsLoading(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSave = () => {
		let request = new AppManagementRequest();
		request.CreatedBy = currentUser.NetworkID;
		request.App = new AppManagementModel();
		request.RequirementNumber = requirementNumber;
		request.App.notificationEvents = appNotifications;
		request.App.id = appID;
		request.RequirementNumber = requirementNumber;
		UpdateAppNotification(request)
			.then(response => {
				setAppNotifications(response.notificationEvents);
			})
			.then(x => setIsLoading(false));
	};

	return (
		<>
			{isLoading ? (
				<Spinner />
			) : (
				<>
					<div className={styles.controlsContainer}>
						<Button
							onClick={e => {
								setIsLoading(true);
								handleSave();
							}}
							startIcon={<MaterialIcon icon='save' />}
							id='updateEmailNotifications_save'
							disabled={readOnly}
						>
							Save
						</Button>
					</div>

					{/* <ApiErrors errors={apiErrors} /> */}
					<Section label='Update Email Notifications'>
						<NotificationUpdate
							notifications={appNotifications}
							setAppNotifications={setAppNotifications}
							appID={appID}
							currentUser={currentUser}
							readOnly={readOnly}
							requirementNumber={requirementNumber}
							multiWorkQueueNotifications={
								multiWorkQueueNotifications
							}
						/>
					</Section>

					{/* <ApiErrors errors={apiErrors} /> */}
					<div className={styles.controlsContainer}>
						<Button
							onClick={e => {
								setIsLoading(true);
								handleSave();
							}}
							startIcon={<MaterialIcon icon='save' />}
							id='updateEmailNotifications_save'
							disabled={readOnly}
						>
							Save
						</Button>
					</div>
				</>
			)}
		</>
	);
};

export default UpdateEmailNotifications;
